import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import '../pricing.css'

let publicUrl = process.env.PUBLIC_URL + "/";
let imagealt = "image";
const data=[
    {
        title:"Standard",
        image:publicUrl + "assets/images/shapes/pricing-i-1-1.png",

        items:[
            {
                title:"Social Media Management",
                subItems:["Facebook","Instagram","LinkedIn"]
            },
            {
                title:"Paid Ads",
                subItems:["Google","Facebook/Instagram"]
            },
            {
                title:"SEO",
            },
            {
                title:"Analytics And Reporting"
            }
        ]
    },
    {
        title:"Enhanced",
        image:publicUrl + "assets/images/shapes/pricing-i-1-1.png",
        ribbon:<span className="pricing-one__corner-ribbon">Best</span>,

        items:[
            {
                title:"Social Media Management",
                subItems:["Facebook","Instagram","LinkedIn"]
            },
            {
                title:"Paid Ads",
                subItems:["Google","Facebook/Instagram"]
            },
            {
                title:"SEO",
            },
            {
                title:"Email Automation"
            },
            {
                title:"Sales Software"
            },
            {
                title:"Leads Generation"
            },
            {
                title:"Analytics And Reporting"
            },
        ]
    },
    {
        title:"Comprehensive",
        image:publicUrl + "assets/images/shapes/pricing-i-1-1.png",
        items:[
            {
                title:"Social Media Management",
                subItems:["Facebook","Instagram","LinkedIn","Twitter","Snapchat","TikTok"]
            },
            {
                title:"Paid Ads",
                subItems:["Google Ads","Facebook/Instagram Ads","LinkedIn Ads"]
            },
            {
                title:"Videography/Video Marketing",
            },
            {
                title:"SEO",
            },
            {
                title:"Landing Page"
            },
            {
                title:"Sales Software"
            },
            {
                title:"Leads Generation"
            },
            {
                title:"Analytics And Reporting"
            },
            {
                title:"Email Automation"
            }
        ]
    }
]
class PricingV4 extends Component {
  render() {



    return (
      <section className="pricing-one pricing-one__pricing-page">
        <div className="container">
          <div className="pricing-one__block">
            <div className="block-title-two text-left">
              <p>get a quote</p>
              <h3>
                Don't Hesitate To Contact <br /> With Us Get A Call
              </h3>
            </div>
            {/* /.block-title-two */}
            <div className="pricing-one__btn-block">
              <ul className="list-unstyled nav nav-tabs">
                <li className="nav-item">
                  <a
                    href="#monthly"
                    className="nav-link active"
                    data-toggle="tab"
                  >
                    Monthly
                  </a>
                </li>
                {/* /.nav-item */}
                <li className="nav-item">
                  <a href="#yearly" className="nav-link " data-toggle="tab">
                    Yearly
                  </a>
                </li>
                {/* /.nav-item */}
              </ul>
              {/* /.list-unstyled nav nav-tabs */}
            </div>
            {/* /.pricing-one__btn-block */}
          </div>
          {/* /.pricing-one__block */}
          <div className="tab-content">
            <div
              className="tab-pane show active  animated fadeInUp"
              id="monthly"

            >
              <div className="row" style={{textAlign:'left'}}>
                  {data.map((services,index)=>{
                      return(
                          <div className="col-lg-4">
                              <div className="pricing-one__single">
                                  <div className="pricing-one__inner cont">
                                      {services.ribbon&&services.ribbon}
                                      <img
                                          src={
                                              services.image
                                          }
                                          alt={imagealt}
                                      />
                                      <div className="pricing-one__top">
                                          <h3>{services.title}</h3>
                                          {/*<p>*/}
                                          {/*    <span>$</span>{services.price}*/}
                                          {/*</p>*/}
                                      </div>
                                      {/* /.pricing-one__top */}
                                      <ul className="pricing-one__list list-unstyled">

                                          {services.items?.map((e,index)=>{
                                              return(
                                                  <li
                                                      style={{
                                                          display: "flex",
                                                          flexDirection: "column",
                                                          justifyContent: "start",
                                                          textAlign:'left'
                                                      }}
                                                  >
                                                      {e.subItems&&<h5 style={{textAlign:"left", marginLeft:"2.5rem"}}>{e.title}</h5>}
                                                      {!e.subItems&&<h5 style={{lineHeight:'0.1',textAlign:"left", marginLeft:"2.5rem"}}>{e.title}</h5>}

                                                      <div
                                                          style={{
                                                              display: "grid",
                                                              gap: "1rem",
                                                              textAlign:"left",
                                                              marginBottom:".5rem",
                                                              marginLeft:'2.5rem'
                                                          }}>
                                                          {e.subItems?.map((x,index)=>{
                                                              return(
                                                                  <div>
                                                                      <i className="far fa-check"></i>{x}
                                                                  </div>
                                                              )
                                                          })}
                                                      </div>
                                                  </li>

                                              )

                                          })}
                                      </ul>
                                      {/* /.pricing-one__list list-unstyled */}
                                      <a href="#" className="thm-btn pricing-one__btn">
                                          Choose Plan <i className="fa fa-angle-double-right" />
                                      </a>
                                      {/* /.thm-btn pricing-one__btn */}
                                  </div>
                                  {/* /.pricing-one__inner */}
                              </div>
                              {/* /.pricing-one__single */}
                          </div>
                      )
                  })}

                {/* /.col-lg-4 */}

                {/* /.col-lg-4 */}
              </div>
              {/* /.row */}
            </div>
            {/* /.tab-pane fade in active */}
            <div className="tab-pane animated fadeInUp " id="yearly">
              <div className="row">
                <div className="col-lg-4">
                  <div className="pricing-one__single">
                    <div className="pricing-one__inner">
                      <img
                        src={
                          publicUrl + "assets/images/shapes/pricing-i-1-1.png"
                        }
                        alt={imagealt}
                      />
                      <div className="pricing-one__top">
                        <h3>Startup</h3>
                        <p>
                          <span>$</span>69.99
                        </p>
                      </div>
                      {/* /.pricing-one__top */}
                      <ul className="pricing-one__list list-unstyled">
                        <li>
                          <i className="far fa-check" />
                          50GB Bandwidth
                        </li>
                        <li>
                          <i className="far fa-check" />
                          Business &amp; Financ Analysing
                        </li>
                        <li>
                          <i className="far fa-check" />
                          24 hour support
                        </li>
                        <li>
                          <i className="far fa-check" />
                          Customer Managemet
                        </li>
                      </ul>
                      {/* /.pricing-one__list list-unstyled */}
                      <a href="#" className="thm-btn pricing-one__btn">
                        Choose Plan <i className="fa fa-angle-double-right" />
                      </a>
                      {/* /.thm-btn pricing-one__btn */}
                    </div>
                    {/* /.pricing-one__inner */}
                  </div>
                  {/* /.pricing-one__single */}
                </div>
                {/* /.col-lg-4 */}
                <div className="col-lg-4">
                  <div className="pricing-one__single">
                    <div className="pricing-one__inner">
                      <span className="pricing-one__corner-ribbon">Best</span>
                      {/* /.pricing-one__corner-ribbon */}
                      <img
                        src={
                          publicUrl + "assets/images/shapes/pricing-i-1-2.png"
                        }
                        alt={imagealt}
                      />
                      <div className="pricing-one__top">
                        <h3>Regular</h3>
                        <p>
                          <span>$</span>79.99
                        </p>
                      </div>
                      {/* /.pricing-one__top */}
                      <ul className="pricing-one__list list-unstyled">
                        <li>
                          <i className="far fa-check" />
                          50GB Bandwidth
                        </li>
                        <li>
                          <i className="far fa-check" />
                          Business &amp; Financ Analysing
                        </li>
                        <li>
                          <i className="far fa-check" />
                          24 hour support
                        </li>
                        <li>
                          <i className="far fa-check" />
                          Customer Managemet
                        </li>
                      </ul>
                      {/* /.pricing-one__list list-unstyled */}
                      <a href="#" className="thm-btn pricing-one__btn">
                        Choose Plan <i className="fa fa-angle-double-right" />
                      </a>
                      {/* /.thm-btn pricing-one__btn */}
                    </div>
                    {/* /.pricing-one__inner */}
                  </div>
                  {/* /.pricing-one__single */}
                </div>
                {/* /.col-lg-4 */}
                <div className="col-lg-4">
                  <div className="pricing-one__single">
                    <div className="pricing-one__inner">
                      <img
                        src={
                          publicUrl + "assets/images/shapes/pricing-i-1-3.png"
                        }
                        alt={imagealt}
                      />
                      <div className="pricing-one__top">
                        <h3>Premium</h3>
                        <p>
                          <span>$</span>99.99
                        </p>
                      </div>
                      {/* /.pricing-one__top */}
                      <ul className="pricing-one__list list-unstyled">
                        <li>
                          <i className="far fa-check" />
                          50GB Bandwidth
                        </li>
                        <li>
                          <i className="far fa-check" />
                          Business &amp; Financ Analysing
                        </li>
                        <li>
                          <i className="far fa-check" />
                          24 hour support
                        </li>
                        <li>
                          <i className="far fa-check" />
                          Customer Managemet
                        </li>
                      </ul>
                      {/* /.pricing-one__list list-unstyled */}
                      <a href="#" className="thm-btn pricing-one__btn">
                        Choose Plan <i className="fa fa-angle-double-right" />
                      </a>
                      {/* /.thm-btn pricing-one__btn */}
                    </div>
                    {/* /.pricing-one__inner */}
                  </div>
                  {/* /.pricing-one__single */}
                </div>
                {/* /.col-lg-4 */}
              </div>
              {/* /.row */}
            </div>
            {/* /.tab-pane fade in active */}
          </div>
          {/* /.tab-content */}
        </div>
        {/* /.container */}
      </section>
    );
  }
}

export default PricingV4;
